/* global gapi */

export default function logoutProcess() {
	gapi.auth2.getAuthInstance().signOut()
	localStorage.removeItem('token')
	localStorage.removeItem('email')
	window.location = '/'
}
